export default __webpack_public_path__ + "static/media/architecture-1.f5e4b2b6.webp";